import TempFile from './tempfile'

export default TempFile